<!-- eslint-disable max-len -->
<template>
  <div>
    <LoadingSpinner v-if="loading" />
    <div
      class="
        block
        fixed
        left-0
        top-0
        w-full
        h-full
        overflow-auto
        black-overlay
        bewerbung-block
      "
    >
      <div
        class="relative w-full bg-white overflow-hidden model-block h-full flex flex-col"
      >
        <div
          class="
            flex
            items-center
            justify-between
            relative
            w-full
            bg-darkgreen
            p-4
            top-block
          "
        >
          <h2
            class="block m-0 text-white text-left text-sm font-bold"
          >
            {{ $t("pages.apply_application.title") }}
          </h2>
         
        </div>
         <div class="tabs custom-tabs">
        <a v-on:click="activetab='1'" v-bind:class="[ activetab === '1' ? 'active' : '' ]">{{ $t("pages.common.buttons.dis300") }}</a>
        <a v-on:click="activetab='2'" v-bind:class="[ activetab === '2' ? 'active' : '' ]">{{ $t("pages.common.buttons.dis152") }}</a>
        
    </div>

    <div class="content grow">
        <div v-if="activetab ==='1'" class="tabcontent p-4">
           <div class="block relative list-item-main mb-4">
                  <div
                    class="
                      flex
                      items-center
                      justify-start
                      list-item-block
                      border-b
                      solid
                      border-agray
                    "
                  >
                    <label
                      class="flex items-center justify-center text-xs pt-2 pb-2"
                    >
                      <span class="flex mr-1">
                        <svg
                          class="w-3 h-3"
                          viewBox="0 0 14 13"
                          fill="none"
                          xmlns="http://www.w3.org/2000/svg"
                        >
                          <path
                            d="M3.3335 0.833008C2.7085 0.833008 2.17643 1.08539 1.8348 1.46973C1.49316 1.85407 1.3335 2.3469 1.3335 2.83301C1.3335 3.31912 1.49316 3.81195 1.8348 4.19629C2.17643 4.58063 2.7085 4.83301 3.3335 4.83301C3.9585 4.83301 4.49056 4.58063 4.83219 4.19629C5.17383 3.81195 5.3335 3.31912 5.3335 2.83301C5.3335 2.3469 5.17383 1.85407 4.83219 1.46973C4.49056 1.08539 3.9585 0.833008 3.3335 0.833008ZM10.6668 0.833008C10.0418 0.833008 9.50977 1.08539 9.16813 1.46973C8.8265 1.85407 8.66683 2.3469 8.66683 2.83301C8.66683 3.31912 8.8265 3.81195 9.16813 4.19629C9.50977 4.58063 10.0418 4.83301 10.6668 4.83301C11.2918 4.83301 11.8239 4.58063 12.1655 4.19629C12.5072 3.81195 12.6668 3.31912 12.6668 2.83301C12.6668 2.3469 12.5072 1.85407 12.1655 1.46973C11.8239 1.08539 11.2918 0.833008 10.6668 0.833008ZM3.3335 1.83301C3.7085 1.83301 3.92643 1.95563 4.0848 2.13379C4.24316 2.31195 4.3335 2.56912 4.3335 2.83301C4.3335 3.0969 4.24316 3.35407 4.0848 3.53223C3.92643 3.71039 3.7085 3.83301 3.3335 3.83301C2.9585 3.83301 2.74056 3.71039 2.58219 3.53223C2.42383 3.35407 2.3335 3.0969 2.3335 2.83301C2.3335 2.56912 2.42383 2.31195 2.58219 2.13379C2.74056 1.95563 2.9585 1.83301 3.3335 1.83301ZM10.6668 1.83301C11.0418 1.83301 11.2598 1.95563 11.4181 2.13379C11.5765 2.31195 11.6668 2.56912 11.6668 2.83301C11.6668 3.0969 11.5765 3.35407 11.4181 3.53223C11.2598 3.71039 11.0418 3.83301 10.6668 3.83301C10.2918 3.83301 10.0739 3.71039 9.91553 3.53223C9.75716 3.35407 9.66683 3.0969 9.66683 2.83301C9.66683 2.56912 9.75716 2.31195 9.91553 2.13379C10.0739 1.95563 10.2918 1.83301 10.6668 1.83301ZM7.00016 4.16634C6.37516 4.16634 5.8431 4.41872 5.50146 4.80306C5.15983 5.1874 5.00016 5.68023 5.00016 6.16634C5.00016 6.65245 5.15983 7.14528 5.50146 7.52962C5.8431 7.91396 6.37516 8.16634 7.00016 8.16634C7.62516 8.16634 8.15722 7.91396 8.49886 7.52962C8.8405 7.14528 9.00016 6.65245 9.00016 6.16634C9.00016 5.68023 8.8405 5.1874 8.49886 4.80306C8.15722 4.41872 7.62516 4.16634 7.00016 4.16634ZM7.00016 5.16634C7.37516 5.16634 7.5931 5.28896 7.75146 5.46712C7.90983 5.64528 8.00016 5.90245 8.00016 6.16634C8.00016 6.43023 7.90983 6.6874 7.75146 6.86556C7.5931 7.04372 7.37516 7.16634 7.00016 7.16634C6.62516 7.16634 6.40722 7.04372 6.24886 6.86556C6.0905 6.6874 6.00016 6.43023 6.00016 6.16634C6.00016 5.90245 6.0905 5.64528 6.24886 5.46712C6.40722 5.28896 6.62516 5.16634 7.00016 5.16634ZM1.50016 5.49967C0.856829 5.49967 0.333496 6.02301 0.333496 6.66634V7.49967C0.333496 8.61967 1.65016 9.49967 3.3335 9.49967H3.40381C3.55381 8.96301 3.94662 8.52624 4.45329 8.30957C4.13662 8.42624 3.7535 8.49967 3.3335 8.49967C2.19016 8.49967 1.3335 7.97301 1.3335 7.49967V6.66634C1.3335 6.57301 1.40683 6.49967 1.50016 6.49967H4.35368C4.34035 6.38967 4.3335 6.27967 4.3335 6.16634C4.3335 5.93634 4.3635 5.71301 4.41683 5.49967H1.50016ZM9.5835 5.49967C9.63683 5.71301 9.66683 5.93634 9.66683 6.16634C9.66683 6.27967 9.65998 6.38967 9.64665 6.49967H12.5002C12.5935 6.49967 12.6668 6.57301 12.6668 6.66634V7.49967C12.6668 7.97301 11.8102 8.49967 10.6668 8.49967C10.2468 8.49967 9.8637 8.42624 9.54704 8.30957C10.0537 8.52624 10.4465 8.96301 10.5965 9.49967H10.6668C12.3502 9.49967 13.6668 8.61967 13.6668 7.49967V6.66634C13.6668 6.02301 13.1435 5.49967 12.5002 5.49967H9.5835ZM5.16683 8.83301C4.52851 8.83301 4.00016 9.36136 4.00016 9.99967V10.833C4.00016 11.4724 4.4268 11.9934 4.97542 12.3226C5.52404 12.6518 6.22875 12.833 7.00016 12.833C7.77158 12.833 8.47628 12.6518 9.0249 12.3226C9.57352 11.9934 10.0002 11.4724 10.0002 10.833V9.99967C10.0002 9.36136 9.47182 8.83301 8.8335 8.83301H5.16683ZM5.16683 9.83301H8.8335C8.93184 9.83301 9.00016 9.90133 9.00016 9.99967V10.833C9.00016 11.022 8.86679 11.2514 8.51058 11.4652C8.15437 11.6789 7.60942 11.833 7.00016 11.833C6.39091 11.833 5.84596 11.6789 5.48975 11.4652C5.13353 11.2514 5.00016 11.022 5.00016 10.833V9.99967C5.00016 9.90133 5.06848 9.83301 5.16683 9.83301Z"
                            fill="#63B15B"
                          />
                        </svg>
                      </span>
                      <span
                        class="flex text-xs text-darkgray1 font-normal mr-2"
                      >
                        {{ $t("pages.apply_application.family") }}:
                      </span>
                      <span class="flex font-semibold text-xs text-darkblack">
                        {{ details.customer.last_name }}-{{
                          details.customer.first_name
                        }}
                      </span>
                    </label>
                  </div>

                  <div
                    class="
                      flex
                      items-center
                      justify-start
                      list-item-block
                      border-b
                      solid
                      border-agray
                    "
                  >
                    <label
                      class="flex items-center justify-center text-xs pt-2 pb-2"
                    >
                      <span class="flex mr-1">
                        <svg
                          class="w-3 h-3"
                          viewBox="0 0 12 15"
                          fill="none"
                          xmlns="http://www.w3.org/2000/svg"
                        >
                          <path
                            d="M6.00016 0.833008C2.87658 0.833008 0.333496 3.37609 0.333496 6.49967C0.333496 7.90194 0.847931 9.18795 1.69287 10.1768L1.69548 10.1794L1.69743 10.182C1.69743 10.182 4.10807 12.9327 4.96631 13.7516C5.54102 14.2996 6.45866 14.2996 7.03337 13.7516C8.01163 12.8186 10.3035 10.1807 10.3035 10.1807L10.3049 10.1787L10.3068 10.1768C11.1525 9.18794 11.6668 7.90194 11.6668 6.49967C11.6668 3.37609 9.12375 0.833008 6.00016 0.833008ZM6.00016 1.83301C8.58325 1.83301 10.6668 3.91659 10.6668 6.49967C10.6668 7.65808 10.2447 8.71054 9.54639 9.52702C9.54184 9.53222 7.19684 12.2142 6.34326 13.0283C6.14531 13.2171 5.85437 13.2171 5.65641 13.0283C4.94302 12.3476 2.46053 9.53522 2.45329 9.52702L2.45264 9.52637C1.75527 8.70995 1.3335 7.65776 1.3335 6.49967C1.3335 3.91659 3.41708 1.83301 6.00016 1.83301ZM6.00016 4.49967C5.37516 4.49967 4.8431 4.75205 4.50146 5.13639C4.15983 5.52073 4.00016 6.01356 4.00016 6.49967C4.00016 6.98579 4.15983 7.47861 4.50146 7.86296C4.8431 8.2473 5.37516 8.49967 6.00016 8.49967C6.62516 8.49967 7.15722 8.2473 7.49886 7.86296C7.8405 7.47861 8.00016 6.98579 8.00016 6.49967C8.00016 6.01356 7.8405 5.52073 7.49886 5.13639C7.15722 4.75205 6.62516 4.49967 6.00016 4.49967ZM6.00016 5.49967C6.37516 5.49967 6.5931 5.6223 6.75146 5.80046C6.90983 5.97861 7.00016 6.23579 7.00016 6.49967C7.00016 6.76356 6.90983 7.02073 6.75146 7.19889C6.5931 7.37705 6.37516 7.49967 6.00016 7.49967C5.62516 7.49967 5.40722 7.37705 5.24886 7.19889C5.0905 7.02073 5.00016 6.76356 5.00016 6.49967C5.00016 6.23579 5.0905 5.97861 5.24886 5.80046C5.40722 5.6223 5.62516 5.49967 6.00016 5.49967Z"
                            fill="#63B15B"
                          />
                        </svg>
                      </span>
                      <span
                        class="flex text-xs text-darkgray1 font-normal mr-2"
                      >
                        {{ $t("pages.apply_application.city") }}:
                      </span>
                      <span class="flex font-semibold text-xs text-darkblack">
                        {{ details.location }}
                      </span>
                    </label>
                  </div>

                  <div
                    class="
                      flex
                      items-center
                      justify-start
                      list-item-block
                      border-b
                      solid
                      border-agray
                    "
                  >
                    <label
                      class="flex items-center justify-center text-xs pt-2 pb-2"
                    >
                      <span class="flex mr-1">
                        <svg
                          class="w-3 h-3"
                          viewBox="0 0 12 14"
                          fill="none"
                          xmlns="http://www.w3.org/2000/svg"
                        >
                          <path
                            d="M5.99984 0.333008C4.16481 0.333008 2.6665 1.83131 2.6665 3.66634C2.6665 5.50137 4.16481 6.99967 5.99984 6.99967C7.83486 6.99967 9.33317 5.50137 9.33317 3.66634C9.33317 1.83131 7.83486 0.333008 5.99984 0.333008ZM5.99984 1.33301C7.29443 1.33301 8.33317 2.37175 8.33317 3.66634C8.33317 4.96093 7.29443 5.99967 5.99984 5.99967C4.70525 5.99967 3.6665 4.96093 3.6665 3.66634C3.6665 2.37175 4.70525 1.33301 5.99984 1.33301ZM1.99268 8.33301C1.26607 8.33301 0.666504 8.93258 0.666504 9.65918V10.1663C0.666504 11.3677 1.42626 12.2971 2.43538 12.8538C3.44451 13.4106 4.72254 13.6663 5.99984 13.6663C7.27714 13.6663 8.55517 13.4106 9.56429 12.8538C10.4247 12.3791 11.0723 11.6205 11.2537 10.6663H11.3338V9.65918C11.3338 8.93258 10.7336 8.33301 10.007 8.33301H1.99268ZM1.99268 9.33301H10.007C10.1931 9.33301 10.3338 9.47312 10.3338 9.65918V9.66634H10.3332V10.1663C10.3332 10.965 9.88459 11.5356 9.08122 11.9788C8.27784 12.4221 7.1392 12.6663 5.99984 12.6663C4.86047 12.6663 3.72183 12.4221 2.91846 11.9788C2.11508 11.5356 1.6665 10.965 1.6665 10.1663V9.65918C1.6665 9.47312 1.80661 9.33301 1.99268 9.33301Z"
                            fill="#63B15B"
                          />
                        </svg>
                      </span>
                      <span
                        class="flex text-xs text-darkgray1 font-normal mr-2"
                      >
                        {{ $t("pages.apply_application.customer") }}:
                      </span>
                      <span class="flex font-semibold text-xs text-darkblack">
                        {{ details.customer.id }}
                      </span>
                    </label>
                  </div>

                  <div
                    class="
                      flex
                      items-center
                      justify-start
                      list-item-block
                      border-b
                      solid
                      border-agray
                    "
                  >
                    <label
                      class="flex items-center justify-center text-xs pt-2 pb-2"
                    >
                      <span class="flex mr-1">
                        <svg
                          class="w-3 h-3"
                          viewBox="0 0 12 14"
                          fill="none"
                          xmlns="http://www.w3.org/2000/svg"
                        >
                          <path
                            d="M5.99984 0.333008C4.16481 0.333008 2.6665 1.83131 2.6665 3.66634C2.6665 5.50137 4.16481 6.99967 5.99984 6.99967C7.83486 6.99967 9.33317 5.50137 9.33317 3.66634C9.33317 1.83131 7.83486 0.333008 5.99984 0.333008ZM5.99984 1.33301C7.29443 1.33301 8.33317 2.37175 8.33317 3.66634C8.33317 4.96093 7.29443 5.99967 5.99984 5.99967C4.70525 5.99967 3.6665 4.96093 3.6665 3.66634C3.6665 2.37175 4.70525 1.33301 5.99984 1.33301ZM1.99268 8.33301C1.26607 8.33301 0.666504 8.93258 0.666504 9.65918V10.1663C0.666504 11.3677 1.42626 12.2971 2.43538 12.8538C3.44451 13.4106 4.72254 13.6663 5.99984 13.6663C7.27714 13.6663 8.55517 13.4106 9.56429 12.8538C10.4247 12.3791 11.0723 11.6205 11.2537 10.6663H11.3338V9.65918C11.3338 8.93258 10.7336 8.33301 10.007 8.33301H1.99268ZM1.99268 9.33301H10.007C10.1931 9.33301 10.3338 9.47312 10.3338 9.65918V9.66634H10.3332V10.1663C10.3332 10.965 9.88459 11.5356 9.08122 11.9788C8.27784 12.4221 7.1392 12.6663 5.99984 12.6663C4.86047 12.6663 3.72183 12.4221 2.91846 11.9788C2.11508 11.5356 1.6665 10.965 1.6665 10.1663V9.65918C1.6665 9.47312 1.80661 9.33301 1.99268 9.33301Z"
                            fill="#63B15B"
                          />
                        </svg>
                      </span>
                      <span
                        class="flex text-xs text-darkgray1 font-normal mr-2"
                      >
                        {{ $t("pages.apply_application.salary_net") }}:
                      </span>
                      <span
                        class="
                          flex
                          align-center
                          font-semibold
                          text-xs text-darkblack
                        "
                      >
                        <span class="flex mr-1">
                          <svg
                            class="w-3.5 h-3.5"
                            viewBox="0 0 13 14"
                            fill="none"
                            xmlns="http://www.w3.org/2000/svg"
                          >
                            <path
                              d="M7.00016 0.833008C3.32418 0.833008 0.333496 3.8237 0.333496 7.49967C0.333496 11.1757 3.32418 14.1663 7.00016 14.1663C10.6761 14.1663 13.6668 11.1757 13.6668 7.49967C13.6668 3.8237 10.6761 0.833008 7.00016 0.833008ZM7.17334 3.83301C8.49667 3.83301 9.06307 4.39182 9.51774 4.84082C9.71441 5.03482 9.7163 5.35118 9.5223 5.54785C9.32863 5.74452 9.01127 5.74641 8.81527 5.55241C8.40827 5.15074 8.08699 4.83301 7.17399 4.83301C6.37166 4.83301 5.67077 5.37067 5.29443 6.16634H6.8335C7.1095 6.16634 7.3335 6.39001 7.3335 6.66634C7.3335 6.94267 7.1095 7.16634 6.8335 7.16634H5.01904C5.00771 7.27567 5.00016 7.38667 5.00016 7.49967C5.00016 7.61267 5.00771 7.72367 5.01904 7.83301H6.8335C7.1095 7.83301 7.3335 8.05667 7.3335 8.33301C7.3335 8.60934 7.1095 8.83301 6.8335 8.83301H5.29443C5.6711 9.62867 6.37101 10.1663 7.17334 10.1663C8.08634 10.1663 8.40793 9.84861 8.81527 9.44694C9.01127 9.25294 9.32863 9.25516 9.5223 9.4515C9.7163 9.64816 9.71441 9.96486 9.51774 10.1585C9.06307 10.6079 8.49699 11.1663 7.17399 11.1663C5.83132 11.1663 4.68353 10.1967 4.22087 8.83301H3.50016C3.22416 8.83301 3.00016 8.60934 3.00016 8.33301C3.00016 8.05667 3.22416 7.83301 3.50016 7.83301H4.01514C4.00647 7.72301 4.00016 7.61234 4.00016 7.49967C4.00016 7.38701 4.00647 7.27634 4.01514 7.16634H3.50016C3.22416 7.16634 3.00016 6.94267 3.00016 6.66634C3.00016 6.39001 3.22416 6.16634 3.50016 6.16634H4.22021C4.68322 4.80267 5.83101 3.83301 7.17334 3.83301Z"
                              fill="#63B15B"
                            />
                          </svg>
                        </span>
                        {{ formatPrice(details.compensation) }} Euro
                      </span>
                    </label>
                  </div>
                </div>

                <div class="block relative">
                  <label
                    class="
                      flex
                      align-center
                      justify-start
                      relative
                      heading-block
                      text-sm
                      text-darkblack
                      font-medium
                      mb-1.5
                    "
                  >
                    <span class="flex mr-1.5">
                      <svg
                        class="w-3.5 h-4 mt-0.5"
                        viewBox="0 0 12 13"
                        fill="none"
                        xmlns="http://www.w3.org/2000/svg"
                      >
                        <path
                          d="M2.16667 0C0.976021 0 0 0.976021 0 2.16667V9.83333C0 11.024 0.976021 12 2.16667 12H9.83333C11.024 12 12 11.024 12 9.83333V2.16667C12 0.976021 11.024 0 9.83333 0H2.16667ZM2.16667 1H9.83333C10.4834 1 11 1.51665 11 2.16667V2.66667H1V2.16667C1 1.51665 1.51665 1 2.16667 1ZM1 3.66667H11V9.83333C11 10.4834 10.4834 11 9.83333 11H2.16667C1.51665 11 1 10.4834 1 9.83333V3.66667ZM8.51367 4.99479C8.44089 4.99345 8.36868 5.00803 8.30211 5.03749C8.23554 5.06695 8.17621 5.11059 8.12826 5.16536L5.48047 8.10677L4.18685 6.81315C4.14078 6.76517 4.08559 6.72686 4.02453 6.70046C3.96346 6.67407 3.89775 6.66013 3.83123 6.65945C3.76471 6.65878 3.69872 6.67138 3.63713 6.69653C3.57555 6.72167 3.51959 6.75885 3.47256 6.80589C3.42552 6.85293 3.38834 6.90888 3.36319 6.97047C3.33805 7.03206 3.32544 7.09804 3.32612 7.16456C3.3268 7.23108 3.34074 7.2968 3.36713 7.35786C3.39352 7.41893 3.43183 7.47411 3.47982 7.52018L5.14648 9.18685C5.19447 9.23486 5.25173 9.2726 5.31477 9.29776C5.37781 9.32293 5.44532 9.33499 5.51317 9.33323C5.58103 9.33146 5.64781 9.3159 5.70946 9.28749C5.7711 9.25907 5.82632 9.21841 5.87175 9.16797L8.87175 5.83464C8.93736 5.76382 8.98107 5.67553 8.99761 5.58042C9.01414 5.48531 9.0028 5.38745 8.96494 5.29865C8.92708 5.20985 8.86432 5.1339 8.78424 5.07998C8.70417 5.02606 8.61019 4.99648 8.51367 4.99479Z"
                          fill="#63B15B"
                        />
                      </svg>
                    </span>
                    {{ $t("pages.apply_application.arrival_date") }}:
                  </label>
                  <div class="block relative form-group mb-2">
                    <label
                      class="
                        block
                        relative
                        text-sm
                        font-normal
                        text-darkgray
                        mb-2
                      "
                      @click="selectedDate(details.arrival_date)"
                    >
                      <label class="custome_radio">
                        <input
                          v-model.number="arrival_date_type"
                          type="radio"
                          value="1"
                          name="radiofil"
                        />
                        <span class="checkmark"></span>
                        <span class="font-normal text-sm text-darkgray1">
                          {{
                            formatDate(
                              details.arrival_date,
                              "DD.MM.YYYY",
                              "YYYY-MM-DD"
                            )
                          }}
                        </span>
                      </label>
                    </label>
                    <label
                      class="
                        flex
                        items-center
                        relative
                        text-sm
                        font-normal
                        text-darkgray
                        mt-1
                      "
                    >
                      <label class="custome_radio flex ali">
                        <input
                          v-model.number="arrival_date_type"
                          type="radio"
                          value="2"
                          name="radiofil"
                        />
                        <span class="checkmark"></span>
                        <span class="font-normal text-sm text-darkgray1">
                          {{
                            $t("pages.apply_application.inquire_about_later")
                          }}:
                        </span>
                      </label>
                    </label>
                
                    <div
                      class="
                        search-card__datepicker
                        input-group
                        ds-cunstome-picker
                      "
                      style="margin-top: 9px"
                      v-if="arrival_date_type === 2"
                    >
                      <span
                        class="input-group-addon col-auto"
                        v-if="arrival_date_type === 2"
                      >
                        <svg
                          width="18"
                          height="18"
                          viewBox="0 0 18 18"
                          fill="none"
                          xmlns="http://www.w3.org/2000/svg"
                        >
                          <path
                            d="M3.25 0C1.46403 0 0 1.46403 0 3.25V14.75C0 16.536 1.46403 18 3.25 18H14.75C16.536 18 18 16.536 18 14.75V3.25C18 1.46403 16.536 0 14.75 0H3.25ZM3.25 1.5H14.75C15.725 1.5 16.5 2.27497 16.5 3.25V4H1.5V3.25C1.5 2.27497 2.27497 1.5 3.25 1.5ZM1.5 5.5H16.5V14.75C16.5 15.725 15.725 16.5 14.75 16.5H3.25C2.27497 16.5 1.5 15.725 1.5 14.75V5.5ZM4.75 7.5C4.41848 7.5 4.10054 7.6317 3.86612 7.86612C3.6317 8.10054 3.5 8.41848 3.5 8.75C3.5 9.08152 3.6317 9.39946 3.86612 9.63388C4.10054 9.8683 4.41848 10 4.75 10C5.08152 10 5.39946 9.8683 5.63388 9.63388C5.8683 9.39946 6 9.08152 6 8.75C6 8.41848 5.8683 8.10054 5.63388 7.86612C5.39946 7.6317 5.08152 7.5 4.75 7.5ZM9 7.5C8.66848 7.5 8.35054 7.6317 8.11612 7.86612C7.8817 8.10054 7.75 8.41848 7.75 8.75C7.75 9.08152 7.8817 9.39946 8.11612 9.63388C8.35054 9.8683 8.66848 10 9 10C9.33152 10 9.64946 9.8683 9.88388 9.63388C10.1183 9.39946 10.25 9.08152 10.25 8.75C10.25 8.41848 10.1183 8.10054 9.88388 7.86612C9.64946 7.6317 9.33152 7.5 9 7.5ZM13.25 7.5C12.9185 7.5 12.6005 7.6317 12.3661 7.86612C12.1317 8.10054 12 8.41848 12 8.75C12 9.08152 12.1317 9.39946 12.3661 9.63388C12.6005 9.8683 12.9185 10 13.25 10C13.5815 10 13.8995 9.8683 14.1339 9.63388C14.3683 9.39946 14.5 9.08152 14.5 8.75C14.5 8.41848 14.3683 8.10054 14.1339 7.86612C13.8995 7.6317 13.5815 7.5 13.25 7.5ZM4.75 12C4.41848 12 4.10054 12.1317 3.86612 12.3661C3.6317 12.6005 3.5 12.9185 3.5 13.25C3.5 13.5815 3.6317 13.8995 3.86612 14.1339C4.10054 14.3683 4.41848 14.5 4.75 14.5C5.08152 14.5 5.39946 14.3683 5.63388 14.1339C5.8683 13.8995 6 13.5815 6 13.25C6 12.9185 5.8683 12.6005 5.63388 12.3661C5.39946 12.1317 5.08152 12 4.75 12ZM9 12C8.66848 12 8.35054 12.1317 8.11612 12.3661C7.8817 12.6005 7.75 12.9185 7.75 13.25C7.75 13.5815 7.8817 13.8995 8.11612 14.1339C8.35054 14.3683 8.66848 14.5 9 14.5C9.33152 14.5 9.64946 14.3683 9.88388 14.1339C10.1183 13.8995 10.25 13.5815 10.25 13.25C10.25 12.9185 10.1183 12.6005 9.88388 12.3661C9.64946 12.1317 9.33152 12 9 12Z"
                            fill="#333333"
                          />
                        </svg>
                      </span>
                      <datepicker
                        input-class="search-card__datepicker-input pkss-text secondary placeholder-gray-500 form-control card__datepicker"
                        v-if="arrival_date_type === 2"
                        v-model="arrival_date"
                        :placeholder="$t('pages.offers.input.placeholder')"
                        :language="lang"
                        format="dd.MM.yyyy"
                        :highlighted="highlighted"
                        :disabled-dates="{ to: yesterday }"
                        @selected="getArrivaldate"
                      />
                    </div>
                  </div>
                </div>

                <div class="ds_form_block">
                  <div class="form-group mb-2" v-if="arrival_date_type === 2">
                 

                    <label
                      class="
                        flex
                        align-center
                        justify-start
                        relative
                        heading-block
                        text-sm
                        text-darkblack
                        font-medium
                        mb-1.5
                      "
                    >
                     
                      {{ $t("pages.apply_application.stay_period") }}
                    </label>
                    <div
                      class="
                        search-card__datepicker
                        input-group
                        ds-cunstome-picker
                      "
                    >
                      <span class="input-group-addon col-auto">
                        <svg
                          width="18"
                          height="18"
                          viewBox="0 0 18 18"
                          fill="none"
                          xmlns="http://www.w3.org/2000/svg"
                        >
                          <path
                            d="M3.25 0C1.46403 0 0 1.46403 0 3.25V14.75C0 16.536 1.46403 18 3.25 18H14.75C16.536 18 18 16.536 18 14.75V3.25C18 1.46403 16.536 0 14.75 0H3.25ZM3.25 1.5H14.75C15.725 1.5 16.5 2.27497 16.5 3.25V4H1.5V3.25C1.5 2.27497 2.27497 1.5 3.25 1.5ZM1.5 5.5H16.5V14.75C16.5 15.725 15.725 16.5 14.75 16.5H3.25C2.27497 16.5 1.5 15.725 1.5 14.75V5.5ZM4.75 7.5C4.41848 7.5 4.10054 7.6317 3.86612 7.86612C3.6317 8.10054 3.5 8.41848 3.5 8.75C3.5 9.08152 3.6317 9.39946 3.86612 9.63388C4.10054 9.8683 4.41848 10 4.75 10C5.08152 10 5.39946 9.8683 5.63388 9.63388C5.8683 9.39946 6 9.08152 6 8.75C6 8.41848 5.8683 8.10054 5.63388 7.86612C5.39946 7.6317 5.08152 7.5 4.75 7.5ZM9 7.5C8.66848 7.5 8.35054 7.6317 8.11612 7.86612C7.8817 8.10054 7.75 8.41848 7.75 8.75C7.75 9.08152 7.8817 9.39946 8.11612 9.63388C8.35054 9.8683 8.66848 10 9 10C9.33152 10 9.64946 9.8683 9.88388 9.63388C10.1183 9.39946 10.25 9.08152 10.25 8.75C10.25 8.41848 10.1183 8.10054 9.88388 7.86612C9.64946 7.6317 9.33152 7.5 9 7.5ZM13.25 7.5C12.9185 7.5 12.6005 7.6317 12.3661 7.86612C12.1317 8.10054 12 8.41848 12 8.75C12 9.08152 12.1317 9.39946 12.3661 9.63388C12.6005 9.8683 12.9185 10 13.25 10C13.5815 10 13.8995 9.8683 14.1339 9.63388C14.3683 9.39946 14.5 9.08152 14.5 8.75C14.5 8.41848 14.3683 8.10054 14.1339 7.86612C13.8995 7.6317 13.5815 7.5 13.25 7.5ZM4.75 12C4.41848 12 4.10054 12.1317 3.86612 12.3661C3.6317 12.6005 3.5 12.9185 3.5 13.25C3.5 13.5815 3.6317 13.8995 3.86612 14.1339C4.10054 14.3683 4.41848 14.5 4.75 14.5C5.08152 14.5 5.39946 14.3683 5.63388 14.1339C5.8683 13.8995 6 13.5815 6 13.25C6 12.9185 5.8683 12.6005 5.63388 12.3661C5.39946 12.1317 5.08152 12 4.75 12ZM9 12C8.66848 12 8.35054 12.1317 8.11612 12.3661C7.8817 12.6005 7.75 12.9185 7.75 13.25C7.75 13.5815 7.8817 13.8995 8.11612 14.1339C8.35054 14.3683 8.66848 14.5 9 14.5C9.33152 14.5 9.64946 14.3683 9.88388 14.1339C10.1183 13.8995 10.25 13.5815 10.25 13.25C10.25 12.9185 10.1183 12.6005 9.88388 12.3661C9.64946 12.1317 9.33152 12 9 12Z"
                            fill="#333333"
                          />
                        </svg>
                      </span>
                      <datepicker
                        input-class="search-card__datepicker-input pkss-text secondary placeholder-gray-500 form-control card__datepicker"
                        :placeholder="$t('pages.offers.input.placeholder')"
                        :language="lang"
                        format="dd.MM.yyyy"
                        :disabled-dates="{ to: yesterday }"
                        :highlighted="highlighted"
                        v-model="datesSeelcted"
                      />
                    </div>
                  </div>

                  <div class="form-group mb-2">
                    <label
                      class="
                        block
                        relative
                        text-sm
                        font-semibold
                        text-darkblack
                        mb-1
                      "
                    >
                      {{ $t("pages.apply_application.remarks") }}:
                    </label>
                    <textarea
                      v-model="notes"
                      cols="4"
                      rows="3"
                      :placeholder="
                        $t('pages.apply_application.wishes_messages')
                      "
                      class="
                        flex
                        items-center
                        relative
                        text-sm
                        font-semibold
                        text-black
                        border border-solid border-color
                        rounded
                        pl-4
                        pr-4
                        pt-3
                        pb-3
                        w-full
                        outline-none
                        shadow-none
                        resize-none
                        rounded
                        placeholder-gray
                        text-darkblack
                      "
                    ></textarea>
                  </div>
                </div>
     
           
        </div>
        <div v-if="activetab ==='2'" class="tabcontent p-4">
             <label class="block text-darkblack text-xs font-bold mb-1-3">
              {{ $t("pages.user_profile.document_upload.Details") }}
              <p class="text-right">{{ RemainCountTotal }}/255</p>
            </label>

              <div class="form-group mb-4">
      
            <textarea
            
              v-model="popup.details"
              class="
                block
                relative
                h-12
                w-full
                border
                solid
                border-color
                text-black
                placeholder-darkgray
                rounded
                h-37
                pl-4
                pr-4
                pt-3
                pb-3.5
                resize-none
                font-medium
              "
              maxlength="255"
              v-on:keyup="displayLiveCDown"
            ></textarea>
            <span v-if="displayError" class="items-end error-msg">
              {{ $t("pages.common.buttons.dis102") }}
            </span>
          </div>

           <div v-if="popup.document.original === null" class="form-group mb-57">
               <label class="block text-darkblack text-xs font-bold mb-1-3">
              {{ $t("pages.user_profile.document_upload.heading") }}
       
            </label>
            <input
              ref="document"
              type="file"
              multiple
              style="display: none"
              accept="application/pdf,application/rtf,text/rtf,.doc,.docx"
              @change="handleFileUpload( $event)"
            />

            <label
              class="
                block
                text-darkgreen text-sm
                font-medium
                flex
                items-center
                justify-start
              "
              
              @click="$refs.document.click()"
            >
              <span class="icon mr-2">
                <svg
                  width="16"
                  height="16"
                  class="w-4 h-4"
                  viewBox="0 0 16 16"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <path
                    fill-rule="evenodd"
                    clip-rule="evenodd"
                    d="M10.5202 1.59212C9.98937 1.59212 9.48028 1.80299 9.10493 2.17834L2.97826 8.30501C2.35273 8.93055 2.0013 9.77896 2.0013 10.6636C2.0013 11.5483 2.35273 12.3967 2.97826 13.0222C3.6038 13.6477 4.45221 13.9992 5.33686 13.9992C6.2215 13.9992 7.06992 13.6477 7.69546 13.0222L13.8221 6.89553C14.0825 6.63518 14.5046 6.63518 14.7649 6.89553C15.0253 7.15588 15.0253 7.57799 14.7649 7.83834L8.63826 13.965C7.76268 14.8406 6.57513 15.3325 5.33686 15.3325C4.09859 15.3325 2.91104 14.8406 2.03546 13.965C1.15987 13.0894 0.667969 11.9019 0.667969 10.6636C0.667969 9.42534 1.15987 8.23779 2.03546 7.3622L8.16212 1.23553C8.78752 0.610135 9.63574 0.258789 10.5202 0.258789C11.4046 0.258789 12.2529 0.610135 12.8783 1.23553C13.5037 1.86093 13.855 2.70916 13.855 3.59361C13.855 4.47805 13.5037 5.32628 12.8783 5.95168L6.74493 12.0783C6.36972 12.4536 5.86082 12.6643 5.33019 12.6643C4.79956 12.6643 4.29067 12.4536 3.91546 12.0783C3.54024 11.7031 3.32945 11.1942 3.32945 10.6636C3.32945 10.133 3.54024 9.62408 3.91546 9.24887L9.57573 3.59526C9.83624 3.33506 10.2583 3.33531 10.5185 3.59581C10.7787 3.85631 10.7785 4.27842 10.518 4.53862L4.85826 10.1917C4.73327 10.3168 4.66279 10.4867 4.66279 10.6636C4.66279 10.8406 4.7331 11.0104 4.85826 11.1355C4.98343 11.2607 5.15319 11.331 5.33019 11.331C5.5072 11.331 5.67696 11.2607 5.80212 11.1355L11.9355 5.00887C12.3106 4.63354 12.5217 4.12431 12.5217 3.59361C12.5217 3.06278 12.3108 2.55369 11.9355 2.17834C11.5601 1.80299 11.051 1.59212 10.5202 1.59212Z"
                    fill="#63B15B"
                  />
                </svg>
              </span>
              {{ $t("pages.user_profile.document_upload.upload_title_detail") }}
            </label>

                <div
                    v-if="documents.length > 0"
                    class="uploaded-file block relative"
                  >
                    <div
                      v-for="(doc, docKey) in documents"
                      :key="`document_${docKey}`"
                      class="
                        file-item
                        flex
                        align-center
                        justify-start
                        p-0.5
                        mb-2
                      "
                    >
                      <div class="w-5/6 flex">
                        <label
                          class="
                            flex
                            align-center
                            justify-start
                            w-full
                            text-sm
                            font-medium
                            text-darkgreen
                          "
                        >
                          <span class="flex mr-2.5">
                            <svg
                              class="w-4 h-4"
                              viewBox="0 0 12 15"
                              fill="none"
                              xmlns="http://www.w3.org/2000/svg"
                            >
                              <path
                                d="M2.1665 0.833008C1.3395 0.833008 0.666504 1.50601 0.666504 2.33301V12.6663C0.666504 13.4933 1.3395 14.1663 2.1665 14.1663H9.83317C10.6602 14.1663 11.3332 13.4933 11.3332 12.6663V6.16634H7.49984C6.67284 6.16634 5.99984 5.49334 5.99984 4.66634V0.833008H2.1665ZM6.99984 1.12598V4.66634C6.99984 4.94201 7.22417 5.16634 7.49984 5.16634H11.0402L6.99984 1.12598ZM3.83317 7.83301H8.1665C8.4425 7.83301 8.6665 8.05701 8.6665 8.33301C8.6665 8.60901 8.4425 8.83301 8.1665 8.83301H3.83317C3.55717 8.83301 3.33317 8.60901 3.33317 8.33301C3.33317 8.05701 3.55717 7.83301 3.83317 7.83301ZM3.82992 10.1663H6.82861C7.10461 10.1663 7.32861 10.39 7.32861 10.6663C7.32895 10.9193 7.14097 11.1288 6.89697 11.1618L6.82926 11.1663H3.83057C3.55457 11.1663 3.33057 10.9423 3.33057 10.6663C3.33057 10.4133 3.51821 10.2039 3.76221 10.1709L3.82992 10.1663Z"
                                fill="#63B15B"
                              />
                            </svg>
                          </span>
                          {{ doc.name }}
                        </label>
                      </div>
                      <div class="w-1/6 flex align-center justify-end pt-1">
                        <label class="flex align-center justify-start">
                          <svg
                            width="14"
                            height="15"
                            viewBox="0 0 14 15"
                            fill="none"
                            xmlns="http://www.w3.org/2000/svg"
                            @click="documents.splice(docKey, 1)"
                          >
                            <path
                              d="M7.00012 0.833008C5.83069 0.833008 4.85692 1.70682 4.69348 2.83301H2.41288C2.3845 2.82815 2.35574 2.82575 2.32695 2.82585C2.30206 2.82638 2.27725 2.82878 2.25273 2.83301H1.16679C1.10053 2.83207 1.03475 2.84431 0.973268 2.86902C0.911784 2.89373 0.855823 2.93041 0.808638 2.97693C0.761453 3.02345 0.723985 3.07889 0.698411 3.14002C0.672838 3.20114 0.659668 3.26675 0.659668 3.33301C0.659668 3.39927 0.672838 3.46487 0.698411 3.526C0.723985 3.58713 0.761453 3.64257 0.808638 3.68909C0.855823 3.73561 0.911784 3.77229 0.973268 3.797C1.03475 3.8217 1.10053 3.83395 1.16679 3.83301H1.87968L2.71887 12.5094C2.80923 13.445 3.60405 14.1663 4.54374 14.1663H9.45585C10.3956 14.1663 11.1904 13.4451 11.2807 12.5094L12.1206 3.83301H12.8335C12.8997 3.83395 12.9655 3.8217 13.027 3.797C13.0885 3.77229 13.1444 3.73561 13.1916 3.68909C13.2388 3.64257 13.2763 3.58713 13.3018 3.526C13.3274 3.46487 13.3406 3.39927 13.3406 3.33301C13.3406 3.26675 13.3274 3.20114 13.3018 3.14002C13.2763 3.07889 13.2388 3.02345 13.1916 2.97693C13.1444 2.93041 13.0885 2.89373 13.027 2.86902C12.9655 2.84431 12.8997 2.83207 12.8335 2.83301H11.7482C11.6951 2.8244 11.6411 2.8244 11.588 2.83301H9.30676C9.14332 1.70682 8.16956 0.833008 7.00012 0.833008ZM7.00012 1.83301C7.62651 1.83301 8.14038 2.25573 8.28723 2.83301H5.71301C5.85987 2.25573 6.37374 1.83301 7.00012 1.83301ZM2.88359 3.83301H11.116L10.2853 12.4131C10.2436 12.8448 9.88944 13.1663 9.45585 13.1663H4.54374C4.11077 13.1663 3.75596 12.8442 3.71432 12.4131L2.88359 3.83301ZM5.82564 5.49251C5.69315 5.49458 5.56689 5.54916 5.47461 5.64425C5.38232 5.73934 5.33156 5.86718 5.33346 5.99967V10.9997C5.33252 11.0659 5.34476 11.1317 5.36947 11.1932C5.39417 11.2547 5.43085 11.3106 5.47738 11.3578C5.5239 11.405 5.57933 11.4425 5.64046 11.4681C5.70159 11.4936 5.76719 11.5068 5.83346 11.5068C5.89972 11.5068 5.96532 11.4936 6.02645 11.4681C6.08758 11.4425 6.14301 11.405 6.18954 11.3578C6.23606 11.3106 6.27274 11.2547 6.29745 11.1932C6.32215 11.1317 6.33439 11.0659 6.33346 10.9997V5.99967C6.33442 5.93275 6.32193 5.86632 6.29674 5.80431C6.27156 5.7423 6.23418 5.68598 6.18682 5.63869C6.13946 5.59139 6.0831 5.55408 6.02105 5.52897C5.95901 5.50387 5.89256 5.49147 5.82564 5.49251ZM8.15898 5.49251C8.02648 5.49458 7.90023 5.54916 7.80794 5.64425C7.71566 5.73934 7.66489 5.86718 7.66679 5.99967V10.9997C7.66585 11.0659 7.67809 11.1317 7.7028 11.1932C7.72751 11.2547 7.76419 11.3106 7.81071 11.3578C7.85723 11.405 7.91267 11.4425 7.9738 11.4681C8.03493 11.4936 8.10053 11.5068 8.16679 11.5068C8.23305 11.5068 8.29866 11.4936 8.35978 11.4681C8.42091 11.4425 8.47635 11.405 8.52287 11.3578C8.56939 11.3106 8.60607 11.2547 8.63078 11.1932C8.65549 11.1317 8.66773 11.0659 8.66679 10.9997V5.99967C8.66775 5.93275 8.65527 5.86632 8.63008 5.80431C8.60489 5.7423 8.56751 5.68598 8.52015 5.63869C8.4728 5.59139 8.41643 5.55408 8.35439 5.52897C8.29235 5.50387 8.2259 5.49147 8.15898 5.49251Z"
                              fill="#333333"
                            />
                          </svg>
                        </label>
                      </div>
                    </div>
                  </div>
          </div>
        </div>
      
    </div>
        <div class="block relative model-body">
          <div class="block px-4">
            <div class="block relative pt-2 pb-2 form-block">
              <div class="block relative form-group mb-2">
               
                
                
             
                <div class="form-group mb-2 w-full flex">
                  <button
                    class="
                      w-full
                      flex
                      items-center
                      justify-center
                      btn_apply
                      rounded-lgtext-white
                      btn_action
                    "
                    @click="submit"
                  >
                    {{ $t("pages.apply_application.apply_now") }}
                  </button>
                  <button
                    class="
                      w-full
                      flex
                      items-center
                      justify-center
                      btn_apply
                      rounded-lg
                      text-white
                      btn_action btn-transparent
                      ml-3
                    "
                    @click="hideMe"
                  >
                    {{ $t("pages.apply_application.abort") }}
                  </button>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    
  </div>
</template>
<script>
import LoadingSpinner from "@/components/LoadingSpinner";
import Datepicker from "vuejs-datepicker";
import SearchCard from "../../components/cards/SearchCard";
import { de, pl, en } from "vuejs-datepicker/dist/locale";
import moment from "moment";
export default {
  name: "ApplyApplication",
  // eslint-disable-next-line vue/no-unused-components
  components: { LoadingSpinner, SearchCard, Datepicker },
  props: {
    details: {
      default: () => {},
      type: Object,
    },
  },
  data() {
    return {
      showPicker: false,
      loading: false,
      arrival_date_type: 1,
      arrival_date: this.details.arrival_date,
      return_date: "",
      setDates: this.details.arrival_date,
      notes: "",
      datesSeelcted: null,
      openDocPopup: false,
      isDisabled: false,
      datePickerVisible: false,
      displayError: false,
      documents: [],
      showModal: false,
      activetab: '1',
         mxLimitCount: 255,
      RemainCountTotal: 0,
      highlighted: {
        dates: [
          new Date(
            new Date().getFullYear(),
            new Date().getMonth(),
            new Date().getDate()
          ),
        ],
        includeDisabled: true,
      },
      popup: {
        title: "",
        details: "",
        document: {
          original: null,
          thumb: null,
        },
      },
    };
  },
  created() {
    this.datesSeelcted = moment(this.arrival_date)
      .add(42, "days")
      .format("MM/DD/YYYY");
  },

  mounted() {
     this.popup.title = "";
      this.popup.details = "";
      this.popup.document.original = null;
      this.popup.document.thumb = null;
      this.documentfile;
      this.openDocPopup = false;
      this.RemainCountTotal = 0;
    
  },
  computed: {
    yesterday() {
      

      let yesterday = moment(this.setDates).format("YYYY-MM-DD");
      yesterday = new Date(yesterday);

      return yesterday;
    },
 disablePopupBtn() {
      return this.popup.details === "" || this.popup.document.original === null;
    },
    lang() {
      if (this.$i18n.locale === "de") {
        return de;
      } else if (this.$i18n.locale === "pl") {
        return pl;
      }

      return en;
    },
  },
  methods: {
    formatPrice(value) {
      return value.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ".");
    },
    selectedDate(date) {
      this.datesSeelcted = moment(date).add(42, "days").format("MM/DD/YYYY");
    },
    getArrivaldate(date) {
      this.datesSeelcted = moment(date).add(42, "days").format("MM/DD/YYYY");
    },
      handleFileUpload(e) {
        
      for (let i = 0; i < e.target.files.length; i++) {
        this.documents.push(e.target.files[i]);
      }
           
    },
    submit() {


      this.$store
        .dispatch("application/apply", {
          offer_id: this.details.offer_id,
          arrival_date:
            this.arrival_date_type === 2
              ? moment(this.arrival_date).format("YYYY-MM-DD")
              : moment(this.arrival_date).format("YYYY-MM-DD"),
          return_date: moment(this.datesSeelcted).format("YYYY-MM-DD"),
          notes: this.notes,
          documents: this.documents,
          description: this.popup.details
        })
        .then((res) => {
          if (res === true) {
            this.$router.push({ name: "Applications" });
          } else {
            this.$store.commit("app/showNotification", {
              heading: res,
              buttons: {
                okay: {
                  text: "OK",
                  action: () => {
                    this.loading = true;
                  },
                },
              },
            });
          }
        });
    },

    hideMe() {
      this.loading = false;
      this.arrival_date_type = 1;
      this.arrival_date = this.details.arrival_date;
      this.return_date = "";
      this.notes = "";
      this.documents = [];
      this.$emit("hideMe");
    },
       displayLiveCDown: function () {
      if (this.popup.details.length === 255) {
        this.displayError = true;
      } else {
        this.displayError = false;
      }
      this.RemainCountTotal = this.popup.details.length;
      // this.displayError = this.RemainCountTotal > 255;
    },
  },
};
</script>
<style scoped>
.ds_form_block .form-group {
  display: block;
  margin: 0 0 8px;
}
.bewerbung-block {
  z-index: 9999999;
}
.search-card__datepicker-icon {
  color: #cbcdda;
  height: 1.2rem;
  margin-left: 10px;
}
.input-group .vdp-datepicker {
  position: relative;
  text-align: left;
  width: 87%;
  padding-right: 10px;
  height: 100%;
  display: flex;
  align-items: center;
  font-size: 14px;
  font-weight: 400;
  color: #676666;
}
.vdp-datepicker * {
  box-sizing: border-box;
  height: 100%;
}
.ds-cunstome-picker {
  position: relative;
}

.ds-cunstome-picker .input-group-addon {
  position: absolute;
  left: 0;
  top: 9px;
  width: 30px !important;
}

.ds-cunstome-picker .vdp-datepicker {
  width: 100%;
  height: 100%;
  align-items: center;
  vertical-align: middle;
}
.my-picker-class {
  border-style: solid !important;
  border-color: #5d5d5d !important;
  border-width: 1px !important;
}
.ds-cunstome-picker .vdp-datepicker * {
  height: 100%;
}

.ds-cunstome-picker .vdp-datepicker .form-control {
  width: 100%;
  padding-left: 35px;
  border: 0 !important;
  border-radius: 5px;
  outline: none !important;
  box-shadow: none !important;
}

.ds-cunstome-picker .form-control {
  width: 100%;
  padding-left: 35px;
  border: 0 !important;
  border-radius: 5px;
  outline: none !important;
  box-shadow: none !important;
}
.card__datepicker {
  width: 100%;
  padding-left: 35px;
  border: 0 !important;
  border-radius: 5px;
  outline: none !important;
  box-shadow: none !important;
  height: 45px;
  background: transparent !important;
}

.search-card__datepicker-input {
  font-weight: bold;
  color: #676666;
  width: 100%;
  padding-left: 30px !important;
  border: 0 !important;
  border-radius: 5px;
  outline: none !important;
  box-shadow: none !important;
  height: 45px;
  background: transparent !important;
}

.search-card__datepicker {
  height: 39px !important;
}
.modal-vue .overlay {
  position: fixed;
  z-index: 9998;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-color: rgba(0, 0, 0, .5);
}

.modal-vue .modal {
  position: relative;
  width: 300px;
  z-index: 9999;
  margin: 0 auto;
  padding: 20px 30px;
  background-color: #fff;
}

.modal-vue .close{
  position: absolute;
  top: 10px;
  right: 10px;
}
.error {
  border: 1px solid #ee5b64;
  box-sizing: border-box;
  border-radius: 4px;
}
.error-msg {
  width: 173px;
  height: 20px;
  left: 0;
  top: 184px;
  font-family: Quicksand, serif;
  font-style: normal;
  font-weight: bold;
  font-size: 13px;
  line-height: 154.5%;
  color: #ee5b64;
}
container {  
    max-width: 620px; 
    min-width: 420px;
    margin: 40px auto;
    font-family: "Nunito Sans", Arial, Helvetica, sans-serif;
    font-size: 0.9em;
    color: #888;
}

/* Style the tabs */
.custom-tabs {
    overflow: hidden;
}

.custom-tabs a{
    float: left;
    cursor: pointer;
    padding: 10px 24px;
    transition: background-color 0.2s;
    font-weight: bold;
    position: relative;
}

/* Change background color of tabs on hover */


/* Styling for active tab */
.custom-tabs a.active {
    color: #63b15b;
    cursor: default;
}
.custom-tabs a.active::before {
    border-bottom: 2px solid #63b15b;
    content: '';
    position: absolute;
    bottom: 0px;
    width: 100%;
    left: 0;
    z-index: 1;
}

/* Style the tab content */
.tabcontent {
   border-top: 2px solid #dfdfdf;
   margin-top: -2px;
   max-height: 480px;
   overflow: auto;
}
.grow{
  flex-grow: 1;
}

.data { width: 120px; }
</style>
